import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { environment } from 'src/environments/environment';

export interface TimetableCellData {
  type: 'CLASS' | 'NO_CLASS' | 'EXAM';
  employeeName?: string;
  startTime?: string;
  endTime?: string;
  duration?: string;
  image?: any;
  payrollId?: any;
  periodName?: any;
  subject?: any;
  topicName?: any;
  subTopicName?: any;
  studentCount?: any;
  imageList?: any;
  sectionStudentCount?: any;
  sectionName?: any
}

@Component({
  selector: 'app-timetable-cell-renderer',
  template: `
    
     <div class="cell-container" [ngClass]="value?.type">
      <!-- CLASS TYPE -->
      <div *ngIf="value?.type === 'CLASS'" class="content-class">
        <div class="header">
        <img *ngIf="value?.image" [src]="value?.image" class="icon" />
        </div>
        <div class="time-row">
          <span class="time">{{ value?.duration }}</span>
        </div>
       
      </div>

      <!-- NO CLASS TYPE -->
      <div *ngIf="value?.type === 'NO_CLASS'" class="content-centered no-class">
        <span>No Class</span>
      </div>

      <!-- EXAM TYPE -->
      <div *ngIf="value?.type === 'EXAM'" class="content-centered exam">
        <span>Exam</span>
      </div>
    </div>
  `,
  styles: [`
     :host {
      display: block;
      width: 100%;
      height: 100%;
      padding: 2px;
      box-sizing: border-box;
    }

    .header{
    align-items: center;
    display: flex;
    justify-content: space-around;
    }

    .cell-container {
      width: 100%;
      height: 100%;
      border-radius: 6px;
       padding: 4px 6px 5px 3px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      font-family: 'Roboto', sans-serif;
      border: 1px solid transparent; /* default */
    }

    /* TYPE STYLES */
    .CLASS {
      background-color: #e6fffa; /* Light green bg */
      border: 1px solid #4fd1c5; /* Green border */
      color: #2c7a7b;
      cursor: pointer;
    }

    .NO_CLASS {
      background-color: #ffeaea; /* Light pink bg */
      border: 1px solid #fc8181; /* Pink border */
      color: #4a4a4a;
    }

    .EXAM {
      background-color: #e3f2fd; /* Light blue bg */
      border: 1px solid #63b3ed; /* Blue border */
      color: #2c5282;
    }

    /* CONTENT LAYOUTS */
   

    .time-row {
      font-size: 0.7rem;
      color: #333;
    }

    .clock-icon {
      margin-right: 4px;
      color: #2c7a7b; /* Match theme */
      font-size: 0.6rem;
    }

    .content-centered {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-weight: 500;
      font-size: 0.9rem;
    }
    
    .no-class span {
      color: #742a2a;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .exam span {
      color: #2a4365;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    }
      .icon{
       height: 45px;
       width: 40px;
      }

  `]
})
export class TimetableCellRenderer implements ICellRendererAngularComp {

  // value!: TimetableCellData;

  // agInit(params: ICellRendererParams): void {
  //   this.value = params.value;
  // }

  // refresh(params: ICellRendererParams): boolean {
  //   this.value = params.value;
  //   return true;
  // }

  value: TimetableCellData | null = null;


  agInit(params: ICellRendererParams): void {
    this.value = params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    return true;
  }

}
